import Grid from '@mui/material/Grid'
import React from 'react'

import Skeleton from '../../../Theme/Skeleton'

export const SkeletonQualificationMapList = () => (
  <Grid
    container
    spacing={2}
  >
    {[...Array(4).keys()].map((key) => (
      <Grid
        item
        xs={3}
        key={key}
      >
        <Skeleton
          variant="rectangular"
          height={192}
        />
      </Grid>
    ))}
  </Grid>
)

export const SkeletonQualificationCheckMap = () => (
  <Grid
    container
    spacing={2}
  >
    {[...Array(4).keys()].map((key) => (
      <Grid
        item
        xs={3}
        key={key}
      >
        <Skeleton height={288} />
      </Grid>
    ))}
    <Grid
      item
      xs={12}
    >
      <Skeleton
        height={80}
        width="100%"
      />
    </Grid>
  </Grid>
)
